<p-dialog
  [header]="'select-a-store' | translate"
  [(visible)]="visible"
  (onHide)="onHide()"
  [modal]="true"
  [closable]="closable"
  [dismissableMask]="closable"
  [closeOnEscape]="closable"
  [draggable]="false"
  [resizable]="false"
  styleClass="store-picker-dialog"
  [style]="{ width: '90vw', maxWidth: '720px' }"
>
  <ng-container *ngIf="loading; else storePickerBody">
    <div class="store-picker-loading">
      <p-progressSpinner strokeWidth="3" />
    </div>
  </ng-container>

  <ng-template #storePickerBody>
    <ng-container *ngIf="uniqueStores.length; else emptyState">
      <div
        *ngIf="uniqueStores.length === 1 && isCurrent(uniqueStores[0])"
        class="store-picker-single-note"
      >
        <i class="pi pi-info-circle"></i>
        <span>{{ "only-store-note" | translate }}</span>
      </div>

      <div class="store-picker-grid">
        <button
          type="button"
          class="store-card"
          *ngFor="let store of uniqueStores; trackBy: trackById"
          (click)="onSelect(store)"
          [disabled]="loading || isCurrent(store)"
          [class.store-card--current]="isCurrent(store)"
        >
          <div class="store-card__logo">
            <img
              *ngIf="store.logo?.url; else logoFallback"
              [src]="store.logo!.url"
              [alt]="storeName(store)"
            />
            <ng-template #logoFallback>
              <div class="store-card__logo-fallback">
                <i class="pi pi-shop"></i>
              </div>
            </ng-template>
          </div>

          <div class="store-card__info">
            <div class="store-card__name">{{ storeName(store) }}</div>
            <div class="store-card__badges">
              <p-tag
                [severity]="store.isActive ? 'success' : 'secondary'"
                [value]="(store.isActive ? 'store-active' : 'store-inactive') | translate"
              />
              <p-tag
                *ngIf="isCurrent(store)"
                severity="info"
                [value]="'current-store' | translate"
              />
            </div>
          </div>

          <i
            class="pi pi-chevron-left store-card__chevron"
            *ngIf="!isCurrent(store)"
          ></i>
          <i
            class="pi pi-check store-card__check"
            *ngIf="isCurrent(store)"
          ></i>
        </button>
      </div>
    </ng-container>

    <ng-template #emptyState>
      <div class="store-picker-empty">
        <i class="pi pi-shop"></i>
        <p>{{ "no-stores-found" | translate }}</p>
      </div>
    </ng-template>
  </ng-template>
</p-dialog>
